import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">品牌专区</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.slice(1, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">分类浏览</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.slice(5, 9).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">更多分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.slice(9).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about#contact"
                    className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    用户协议
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="text-xl font-bold font-heading text-accent-500">51</span>
              <span className="text-base font-bold font-heading text-foreground-100">视频</span>
            </Link>
            <p className="text-xs text-foreground-500">
              &copy; 2026 51视频. 蓝光4K超清无广告不缓冲免费在线观看
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}